import { useState } from 'react'
import * as S from './style'
import { ModalFullTruckLoad } from '../modal-full-truck-load';
import { generateUrlRedirect } from './utils';
import intl from 'react-intl-universal'
import { loadCompositionBrewerySideActive } from 'services/general-settings/get-general-settings';
import IconTruckPlus from 'components/icons/icn-truck-plus.icon';
import PropTypes from 'prop-types'
import ButtonIcon from 'components/button-icon';

export const ButtonLoadCompositionPlus = ({ isFullTruckLoad, hidden, item, history, ...rest }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleClick = () => {
    if (isFullTruckLoad) {
      setOpenModal(true)
    } else {
      goToLoadCompositionBuilding(false)
    }
  }

  if (hidden || !loadCompositionBrewerySideActive()) {
    return null;
  }

  const goToLoadCompositionBuilding = (fullTruckLoad) => history.push(generateUrlRedirect(item, fullTruckLoad))

  return (
    <S.Wrapper title={intl.get('commons.addLoadComposition')}>
      <ButtonIcon
        buttonType="secondary"
        buttonIcon={<IconTruckPlus />}
        onClick={handleClick}
        {...rest}
      />
      {openModal &&
        <ModalFullTruckLoad
          open={openModal}
          handleClose={() => setOpenModal(false)}
          item={item}
          goToLoadCompositionBuilding={goToLoadCompositionBuilding}
        />
      }
    </S.Wrapper>
  )
}

ButtonLoadCompositionPlus.propTypes = {
  isFullTruckLoad: PropTypes.bool,
  hidden: PropTypes.bool,
  item: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func
  })
}
